const faq = () => {
	const faqBlocks = document.querySelectorAll('.faq__block');
	
	faqBlocks.forEach(block => {
		const head = block.querySelector('.faq__head');
		const body = block.querySelector('.faq__body');

		body.style.maxHeight = '0';
		
		head.addEventListener('click', () => {
			const isOpen = block.classList.contains('active');
			
			if (isOpen) {
				// Закриваємо
				body.style.maxHeight = '0';
				block.classList.remove('active');
			} else {
				// Відкриваємо поточний
				body.style.maxHeight = (body.scrollHeight + 24) + 'px';
				block.classList.add('active');
			}
		});
	});
};
export default faq;